var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 495 495",
    style: {
      enableBackground: "new 0 0 495 495"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8700"
    },
    d: "M333.73,135.64L367.4,10.42h-33.19l-5.07,3.41c-6.71,4.52-10.4,7.01-19.76,7.01 c-9.37,0-13.06-2.49-19.77-7.01C280.94,8,269.07,0,247.5,0v135.64H333.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC7400"
    },
    d: "M403.8,196.95c-18.08-26.12-42.08-47.06-70.07-61.31H247.5v65.541h15v12.579 c24.762,6.63,43.053,29.253,43.053,56.078h-30c0-9.954-5.216-18.708-13.053-23.688v57.858l2.501,0.79 c26.15,8.261,40.552,27.923,40.552,55.365c0,26.824-18.291,49.448-43.053,56.078v12.579h-15V495h190V305 C437.5,266.15,425.85,228.78,403.8,196.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC7400"
    },
    d: "M275.553,360.163c0-11.873-3.985-19.388-13.053-24.096v47.784 C270.338,378.87,275.553,370.117,275.553,360.163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8700"
    },
    d: "M232.5,428.819V416.24c-24.762-6.63-43.053-29.253-43.053-56.078h30 c0,9.954,5.216,18.708,13.053,23.688v-57.858l-2.5-0.79c-26.151-8.261-40.553-27.923-40.553-55.365 c0-26.824,18.291-49.448,43.053-56.078v-12.579h15V135.64h-86.23c-27.99,14.25-51.99,35.19-70.07,61.31 C69.15,228.78,57.5,266.15,57.5,305v190h190v-66.181H232.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8700"
    },
    d: "M219.447,269.837c0,11.873,3.985,19.388,13.053,24.096v-47.784 C224.662,251.13,219.447,259.883,219.447,269.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M247.5,0c-21.58,0-33.45,8-42.12,13.83c-6.7,4.52-10.4,7.01-19.76,7.01 c-9.36,0-13.05-2.49-19.76-7.01l-5.07-3.41h-33.2l33.68,125.22h86.23V0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD00"
    },
    d: "M232.5,213.76c-24.762,6.63-43.053,29.253-43.053,56.078c0,27.442,14.402,47.104,40.553,55.365 l2.5,0.79v57.858c-7.838-4.981-13.053-13.734-13.053-23.688h-30c0,26.824,18.291,49.448,43.053,56.078v12.579h30V416.24 c24.762-6.63,43.053-29.253,43.053-56.078c0-27.442-14.402-47.104-40.552-55.365l-2.501-0.79v-57.858 c7.838,4.981,13.053,13.734,13.053,23.688h30c0-26.824-18.291-49.448-43.053-56.078v-12.579h-30V213.76z M219.447,269.837 c0-9.954,5.216-18.708,13.053-23.688v47.784C223.432,289.225,219.447,281.71,219.447,269.837z M275.553,360.163 c0,9.954-5.216,18.708-13.053,23.688v-47.784C271.568,340.775,275.553,348.29,275.553,360.163z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money-bag.24e9903a32448aed4b398b275ae3775e.svg";
export { ForwardRef as ReactComponent };